import FetchConfig from "./fetcher.js"

export default {
    WordGetByWord: async function(word, callback) {
        await fetch(FetchConfig.MainHost + '/words/word?word=' + word, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => callback(data))
            .catch(error => {
                console.error("There was an error! word", error);
            });
    }
}
